// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K1AIJ24VQxMwNdEi6BPn{justify-content:space-between;align-items:center;height:32px;padding-left:8px;padding-right:8px;display:flex}.K1AIJ24VQxMwNdEi6BPn.xlwHyBrGzI4IbDA6Wkxo{margin-top:0;margin-bottom:0;padding-left:0}.K1AIJ24VQxMwNdEi6BPn.E0ZegoS8b8kdJMdrxY2l,.K1AIJ24VQxMwNdEi6BPn.P_f8HZTiYaoQ3BPEfsVl{padding:0}.K1AIJ24VQxMwNdEi6BPn.n6OiXtggNIsgioMqiACg{padding-left:0;padding-right:0}.R4AAbCho7ESELTThEjI1{display:flex}.ef9zp3FzVPso5J0eDpYh{justify-content:center;align-items:center;gap:8px;display:flex}.VoxOrwEbCgWwPMd8LeAk{background:var(--background-primary-inverted-disabled,rgba(255,255,255,.1));color:var(--content-primary-secondary-inverted);border-radius:4px;padding:.5px 4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `K1AIJ24VQxMwNdEi6BPn`,
	"collapse": `xlwHyBrGzI4IbDA6Wkxo`,
	"noPadding": `E0ZegoS8b8kdJMdrxY2l`,
	"noBorder": `P_f8HZTiYaoQ3BPEfsVl`,
	"isUnderline": `n6OiXtggNIsgioMqiACg`,
	"flex": `R4AAbCho7ESELTThEjI1`,
	"aside": `ef9zp3FzVPso5J0eDpYh`,
	"tooltipElement": `VoxOrwEbCgWwPMd8LeAk`
};
export default ___CSS_LOADER_EXPORT___;
